import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-gray-600 dark:text-gray-300" };
const _hoisted_2 = { class: "text-sm-but-a-bit-smaller text-primary-900 dark:text-white" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.teams.new.buySeats')
};
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useNewTeamStore } from '@/pinia_stores/newTeam';
import { useSeatsValidations } from '@/composables/seatsValidations';
import SeatsModifier from '@/components/workspaces/SeatsModifier.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'SeatsForm',
    setup(__props) {
        const store = useStore();
        const newTeamStore = useNewTeamStore();
        const workspace = computed(() => store.getters.workspace);
        const { users, invitesSearchTerm, seatsToBuy } = storeToRefs(newTeamStore);
        const { seats, requiredSeatsToBuy } = useSeatsValidations({
            selectedUsers: users,
            searchTerm: invitesSearchTerm,
            seatsToBuy,
            workspace: workspace
        });
        onMounted(() => {
            newTeamStore.seatsToBuy = requiredSeatsToBuy.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('caption')), 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('seats_available', { taken: _unref(seats), available: 0 })), 1),
                _createVNode(SeatsModifier, {
                    modelValue: _unref(newTeamStore).seatsToBuy,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(newTeamStore).seatsToBuy) = $event)),
                    workspace: _unref(workspace)
                }, null, 8, ["modelValue", "workspace"])
            ]));
        };
    }
});
